const PORT = window.location.port;


const BASE_URL = PORT == 3006 ? window.location.origin.replace(":"+window.location.port, `:3000`)+"/api" : window.location.origin+"/api";
//const BASE_URL = window.location.origin+"/api";

const ENDPOINT_ROUTES = {
    auth: "/auth",
    rajcompanies: "/rajcompanies",
    clients: "/clients",
    buildings: "/buildings",
    users:"/users",
    teams:"/teams",
    offers:"/offers",
    notes:"/notes",
    calendar:"/calendar",
    todos:"/todo",
    protocols:"/protocols",
    devices:"/devices",
    assortments:"/assortments",
    offerPrices:"/offer_prices",
    instructions:"/instructions",
    invoices:"/invoices",
    workTime:"/worktime",
    settings:"/settings"
}


export { BASE_URL, ENDPOINT_ROUTES };
